import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import ForgotPassword from "./components/ForgotPassword";
import PersonalInformation from "./components/PersonalInformation";
import ChangePassword from "./components/ChangePassword";
import Categories from "./components/Categories";
import Products from "./components/Products";
import Units from "./components/Units";
import Users from "./components/Users";
import Accounts from "./components/Accounts";
import SalesHistory from "./components/SalesHistory";
import { DashboardProvider } from "./context/DashboardContext";
import { ManagementProvider } from "./context/ManagementContext";
import JournalEntries from "./components/JournalEnteries";
import GeneralLedger from "./components/GeneralLedger";
import PettyCash from "./components/PettyCash";
import BankReconciliation from "./components/BankReconciliation";
import Vendor from "./components/Vendors";
import Bills from "./components/Bills";
import PurchaseOrders from "./components/PurchaseOrders";
import Customers from "./components/Customers";
import Invoicing from "./components/Invoicing";
import PaymentTracking from "./components/PaymentTracking";
import IncomeTracking from "./components/IncomeTracking";
import Salary from "./components/Salary";
import Payroll from "./components/Payroll";
import LeaveAttendanceTracking from "./components/LeaveAttendanceTracking";
import Departments from "./components/Departments";
import Ranks from "./components/Ranks";
import SalaryStructure from "./components/SalaryStructure";
import TrialBalance from "./components/TrialBalance";
import BalanceSheet from "./components/BalanceSheet";
import IncomeStatement from "./components/IncomeStatement";
import CashFlowStatement from "./components/CashFlowStatement";
import FinancialRatios from "./components/FinancialRatios";
import SalesEntry from "./components/SalesEntry";

function App() {
  return (
    <>
      <UserAuthContextProvider>
        <DashboardProvider>
          <ManagementProvider>
            <Routes>              
              <Route
                path="/home"
                element={<ProtectedRoute><Home /></ProtectedRoute>}
              />
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/personal-information" element={<ProtectedRoute><PersonalInformation /></ProtectedRoute>} />
              <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />

              <Route path="/categories" element={<ProtectedRoute><Categories/></ProtectedRoute>} />
              <Route path="/accounts" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />
              <Route path="/journal-entries" element={<ProtectedRoute><JournalEntries /></ProtectedRoute>} />
              <Route path="/general-ledger" element={<ProtectedRoute><GeneralLedger /></ProtectedRoute>} />
              <Route path="/petty-cash" element={<ProtectedRoute><PettyCash /></ProtectedRoute>} />
              <Route path="/bank-reconciliation" element={<ProtectedRoute><BankReconciliation /></ProtectedRoute>} />
              <Route path="/vendors" element={<ProtectedRoute><Vendor /></ProtectedRoute>} />
              <Route path="/bills" element={<ProtectedRoute><Bills /></ProtectedRoute>} />
              <Route path="/purchase-orders" element={<ProtectedRoute><PurchaseOrders /></ProtectedRoute>} />
              <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
              <Route path="/invoicing" element={<ProtectedRoute><Invoicing /></ProtectedRoute>} />
              <Route path="/payment-tracking" element={<ProtectedRoute><PaymentTracking /></ProtectedRoute>} />              
              <Route path="/income-tracking" element={<ProtectedRoute><IncomeTracking /></ProtectedRoute>} />
              <Route path="/departments" element={<ProtectedRoute><Departments /></ProtectedRoute>} />
              <Route path="/ranks" element={<ProtectedRoute><Ranks /></ProtectedRoute>} />
              <Route path="/staff" element={<ProtectedRoute><Users/></ProtectedRoute>} />
              <Route path="/salary" element={<ProtectedRoute><Salary /></ProtectedRoute>} />
              <Route path="/salary-structure" element={<ProtectedRoute><SalaryStructure /></ProtectedRoute>} />
              <Route path="/payroll" element={<ProtectedRoute><Payroll /></ProtectedRoute>} />
              <Route path="/trial-balance" element={<ProtectedRoute><TrialBalance /></ProtectedRoute>} />
              <Route path="/balance-sheet" element={<ProtectedRoute><BalanceSheet /></ProtectedRoute>} />
              <Route path="/income-statement" element={<ProtectedRoute><IncomeStatement /></ProtectedRoute>} />
              <Route path="/cash-flow-statement" element={<ProtectedRoute><CashFlowStatement /></ProtectedRoute>} />
              <Route path="/financial-ratios" element={<ProtectedRoute><FinancialRatios /></ProtectedRoute>} />
            
              <Route path="/products" element={<ProtectedRoute><Products/></ProtectedRoute>} />
              <Route path="/units" element={<ProtectedRoute><Units/></ProtectedRoute>} />
              <Route path="/sales-history" element={<ProtectedRoute><SalesHistory /></ProtectedRoute>} />
            </Routes>
          </ManagementProvider>
        </DashboardProvider>
      </UserAuthContextProvider>
    </>
  );
}

export default App;